/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
(
    function (skyward, $, undefined)
    {
        skyward.texasassessmentsloginbutton = skyward.texasassessmentsloginbutton || {};

        var init = function (selector)
        {
            // Initialize Texas Assessments Login Form
            if ($(selector).find('.texasassessmentsloginbutton').length > 0)
            {
                var element = $(selector).find('.texasassessmentsloginbutton');
                element.on('click', logRedirect);
            }
        };

        var logRedirect = function (e)
        {
            var loginButton = $(this);

            var accessMode = $('#accessmode').val();
            $.ajax({
                url: skyward.global.virtualDir + 'Student/Student/LogTexasAssessmentsLogin' + accessMode,
                type: 'POST',
                dataType: 'JSON',
                async: false,
                cache: false,
                headers: { "cache-control": "no-cache" },
                data:
                {
                    studentID: loginButton[0].getAttribute('data-id'),
                    studentidhash: loginButton[0].getAttribute('data-studentidhash'),
                }
            });

            var url = loginButton.attr('data-formaction');

            var formData =
            {
                accesscode: loginButton.attr('data-accesscode'),
                dateofbirth: loginButton.attr('data-dateofbirth'),
                name: loginButton.attr('data-name')
            };

            var form = skyward.global.createHiddenInputForm(url, formData, true, false);
            skyward.global.submitAndRemoveHiddenInputForm(form);
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
